import * as React from 'react';
import { t } from 'i18next';

import { LayoutType } from '../../constants/LayoutConstants';
import { VisibilityActions } from '../../actions/VisibilityActions';
import { Overlay } from '../../constants/Enums';
import { OverlayCloseButton } from './OverlayCloseButton';
import { UICoreButton } from '../UICoreButton';
import { PconLoginActions } from '../../actions/PconLoginActions';
import { PRODUCT_NAME } from '../../App';

interface PconLoginQuestionProps {
    layoutType: LayoutType;
}

export class PconLoginQuestion extends React.PureComponent<PconLoginQuestionProps> {
    public render(): JSX.Element {
        return (
            <div className="overlay-frame overlay-full">
                <div className="overlay-content">
                    <OverlayCloseButton show={true}/>
                    <div className="pcon-login-question">
                        <div className="pcon-login-image"/>
                        <div className="overlay-text-big">
                            <div>{t('Welcome to {{productName}}!', {productName: PRODUCT_NAME})}</div>
                        </div>
                        <div className="overlay-text">
                            <div>{t('Already have a pCon.update account?')}</div>
                            <div>{t('Log in to gain access to all your manufacturer catalogs')}</div>
                        </div>
                        <UICoreButton color="green" align="block" onClick={PconLoginActions.login} label={t('Log In')}/>
                        <UICoreButton color="grey" align="block" onClick={this.noLogin} label={t('Skip Login')}/>
                    </div>
                </div>
            </div>
        );
    }

    protected noLogin(): void {
        VisibilityActions.changeOverlay(Overlay.NONE);
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/overlay/PconLoginQuestion.tsx